export const setSpaces = payload => ({
    type: 'setSpaces',
    payload,
})
